import { useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import { StrapiComponentType, StrapiCollectionType } from "@/src/type";

import styles from "./Features.module.scss";
import theme from "@/styles/scss/theme.module.scss";

interface FeaturesProps {
  propertyUnitDetails: StrapiComponentType.Section.PropertyUnitDetails;
  propertyFloorplan?: StrapiCollectionType.PropertyFloorplan;
}

function Features({ propertyUnitDetails, propertyFloorplan }: FeaturesProps) {
  const breakpointKey = `@media (max-width: ${theme.breakpointMDNum}px)`;
  const [navigationOption, setNavigationOption] = useState<"home" | "building">("home");
  const propertyAmenities = (propertyFloorplan?.propertyAmenities ?? "").split(",").map((amenity) => (amenity ?? "").trim());
  const homeAmenities = (propertyFloorplan?.homeAmenities ?? "").split(",").map((amenity) => (amenity ?? "").trim());

  /**
   * when the user clicks a tab button switch what is render and update the url
   */
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setNavigationOption(newValue as "home" | "building");
  };

  return (
    <div className={styles.container}>
      <Tabs
        orientation="horizontal"
        value={navigationOption}
        onChange={handleChange}
        aria-label="Navigation Options"
        scrollButtons="auto"
        sx={{
          "& .MuiTabs-flexContainer": {
            width: "100%",
            borderBottom: `1px solid ${theme.primaryMain}33`,
            [breakpointKey]: {
              width: "unset",
            },
          },
          ".MuiTabs-indicator": {
            left: 0,
            width: "4px",
          },
          ".MuiTabs-fixed": {
            borderBottom: `1px solid ${theme.primaryMain}33`,
          },
          ".MuiTabs-flexContainer button": {
            padding: "5px 50px",
            [breakpointKey]: {
              padding: "0px 4px",
              width: "50%",
            },
          },
        }}
      >
        <Tab
          value="home"
          label={
            <Typography
              variant="body1"
              fontFamily={"var(--poppins)"}
            >
              {propertyUnitDetails.homeFeaturesTitle}
            </Typography>
          }
        />
        <Tab
          value="building"
          label={
            <Typography
              variant="body1"
              fontFamily={"var(--poppins)"}
            >
              {propertyUnitDetails.buildingFeaturesTitle}
            </Typography>
          }
        />
      </Tabs>
      {navigationOption === "home" && (
        <ul className={styles.features}>
          {(homeAmenities ?? []).map((amenity, i) => (
            <li
              key={i}
              className={styles.featureLabel}
            >
              {amenity}
            </li>
          ))}
        </ul>
      )}
      {navigationOption === "building" && (
        <ul className={styles.features}>
          {(propertyAmenities ?? []).map((amenity, i) => (
            <li
              key={i}
              className={styles.featureLabel}
            >
              {amenity}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Features;
